import localConfig from '@/config';

export enum MainAppRoutes {
  Dashboard = '/early/',
  AI = '/ai/',
  Terminal = '/terminal/',
  Bridge = '/bridge/',
  Streams = '/streams/',
}

export enum SynthRoutes {
  Dashboard = '/dashboard/',
  LiquidityProvision = '/insights/lp/',
  OptionsPricing = '/insights/options-pricing/',
  LiquidationProbabilities = '/insights/dex/',
  Terminal = '/synth-terminal/',
}

export const isSynthRoute = (pathName: string) =>
  Object.values(SynthRoutes).some((route) => pathName.startsWith(route));

export const isMainAppRoute = (pathName: string) =>
  Object.values(MainAppRoutes).some((route) => pathName.startsWith(route));

const isSynth = localConfig.isSynth;
const isMainApp = !isSynth;

export type Link = {
  href: string;
  text: string;
  show?: boolean;
  disabled?: boolean;
  target?: string;
  icon?: string;
};

export const navLinks = (isInIframe?: boolean): Array<Link & { children?: Array<Link> }> => [
  {
    href: MainAppRoutes.Dashboard,
    text: 'Dashboard',
    show: isMainApp,
  },
  {
    href: '',
    text: 'Dashboards',
    show: isSynth,
    children: [
      // these links are absolute as we have unified Synth header for many projects
      {
        href: isInIframe ? 'https://dashboard.synthdata.co/dashboard/' : SynthRoutes.Dashboard,
        text: 'Miner Predictions',
        target: '_blank',
      },
      {
        href: isInIframe ? 'https://dashboard.synthdata.co/insights/lp/' : SynthRoutes.LiquidityProvision,
        text: 'Liquidity Provision',
        target: '_blank',
      },
      {
        href: isInIframe ? 'https://dashboard.synthdata.co/insights/options-pricing/' : SynthRoutes.OptionsPricing,
        text: '0DTE Options Pricing',
        target: '_blank',
      },
      {
        href: isInIframe ? 'https://dashboard.synthdata.co/insights/dex/' : SynthRoutes.LiquidationProbabilities,
        text: 'Liquidation Probabilities',
        target: '_blank',
      },
      {
        href: 'https://volatility.synthdata.co/',
        text: 'Volatility',
        target: '_blank',
      },
    ],
  },
  {
    href: 'https://miners.synthdata.co',
    text: 'Miners',
    show: isSynth,
    target: '_blank',
  },
  {
    href: MainAppRoutes.AI,
    text: 'AI Agents',
    show: false,
  },
  {
    href: MainAppRoutes.Terminal,
    text: 'AI Terminal',
    show: isMainApp,
  },
  {
    href: 'https://trade.mode.network/',
    text: 'Trade',
    show: isMainApp,
    target: '_blank',
  },
  // {
  //   href: '/synth-terminal/',
  //   text: 'AI Terminal',
  //   show: isSynth,
  // },
  {
    href: '',
    text: 'API',
    show: isSynth,
    children: [
      {
        href: 'https://api.synthdata.co/docs',
        text: 'Mainnet',
        target: '_blank',
      },
      {
        href: 'https://api-testnet.synthdata.co/docs',
        text: 'Testnet',
        target: '_blank',
      },
    ],
  },
  {
    text: 'Docs',
    href: 'https://github.com/mode-network/synth-subnet/blob/main/README.md',
    show: isSynth,
    target: '_blank',
  },
  {
    href: 'https://github.com/mode-network/synth-subnet',
    text: 'Github',
    show: isSynth,
    target: '_blank',
    icon: '/assets/icons/github-icon.svg',
  },
  {
    href: 'https://mirror.xyz/synthdata.eth',
    text: 'Mirror',
    show: isSynth,
    target: '_blank',
    icon: '/assets/icons/mirror-icon.svg',
  },
  {
    href: MainAppRoutes.Bridge,
    text: 'Bridge',
    show: isMainApp,
  },
  {
    href: MainAppRoutes.Streams,
    text: 'Streams',
    show: isMainApp,
  },
  {
    href: '',
    text: 'Governance',
    show: isMainApp,
    children: [
      {
        href: 'https://gov.mode.network/',
        text: 'Voting',
        icon: '/assets/icons/voting.svg',
        target: '_blank',
      },
      {
        href: 'https://forum.mode.network/',
        text: 'Forum',
        icon: '/assets/icons/forum.svg',
        target: '_blank',
      },
    ],
  },
];
